import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75c1159d")

_pushScopeId("data-v-75c1159d")
const _hoisted_1 = { class: "airport-picker" }
const _hoisted_2 = { style: {"float":"left"} }
const _hoisted_3 = { style: {"float":"right"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_select, {
      modelValue: _ctx.pickedAirport,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pickedAirport = $event)),
      filterable: "",
      placeholder: "请选择机场",
      onChange: _ctx.change
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.airportList, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.airportName,
            value: item.airportName
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_2, _toDisplayString(item.airportName), 1),
              _createVNode("span", _hoisted_3, _toDisplayString(item.airportCity), 1)
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onChange"])
  ]))
})